export const buttonBg = {
  background:
    "linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(135,220,68,1) 100%)",
};
